import { render } from "./SendLicenseEmail.vue?vue&type=template&id=f6f25cfe&scoped=true&ts=true"
import script from "./SendLicenseEmail.vue?vue&type=script&lang=ts"
export * from "./SendLicenseEmail.vue?vue&type=script&lang=ts"

import "./SendLicenseEmail.vue?vue&type=style&index=0&id=f6f25cfe&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f25cfe"]])

export default __exports__